document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector('.content-slider-product')) {
    initializerPDP();
  }
});

function initializerPDP() {
  // Variables para almacenar referencias a los sliders
  let mainSwiper;
  let thumbsSwiper;

  // Obtener el estilo de carrusel seleccionado
  const mainSlider = document.querySelector('.content-slider-product');
  const carouselStyle = mainSlider ? mainSlider.getAttribute('data-carousel-style') : 'thumbnails';

  // Inicializar el carrusel según el estilo seleccionado
  if (carouselStyle === 'thumbnails' && document.querySelector('.content-thumbsSlider-product')) {
    // Inicializar el carrusel con thumbnails
    thumbsSwiper = new Swiper(".content-thumbsSlider-product", {
      direction: "vertical",
      spaceBetween: 6,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    mainSwiper = new Swiper(".content-slider-product", {
      spaceBetween: 5,
      thumbs: {
        swiper: thumbsSwiper,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  } else {
    // Inicializar el carrusel solo con dots
    mainSwiper = new Swiper(".content-slider-product", {
      spaceBetween: 5,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        /*dynamicBullets: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },*/
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    // Asegurar que los dots sean visibles cuando se usa este estilo
    /*
    const paginationEl = document.querySelector('.swiper-pagination');
    if (paginationEl) {
      paginationEl.style.display = 'flex';
      paginationEl.style.justifyContent = 'center';
      paginationEl.style.marginTop = '10px';
    }
    */
  }

  const subLists = document.querySelectorAll(".content-subcription-list");

  subLists.forEach((list) => {
    const header = list.querySelector(".header-subcrition");
    const addToCart = list.querySelector(".content-list-button-add-to-cart");

    header.addEventListener("click", function (e) {
      if (e.target.closest(".button-add-to-cart")) return;

      subLists.forEach((l) => {
        l.classList.remove("active");
        const btnCart = l.querySelector(".content-list-button-add-to-cart");
        if (btnCart) {
          btnCart.classList.remove("active");
          btnCart.style.maxHeight = null;
        }
      });

      list.classList.add("active");
      if (addToCart) {
        addToCart.classList.add("active");
        addToCart.style.maxHeight = addToCart.scrollHeight + "px";
      }
    });

    if (list.classList.contains("active") && addToCart) {
      addToCart.classList.add("active");
      addToCart.style.maxHeight = addToCart.scrollHeight + "px";
    }
  });

  function updateDiscountBadge() {
    const isOneTime = document.querySelector(".content-subcription-list.is-onetime.active");
    const isSixPackActive = document.querySelector('.flavor-switcher__item.discount-tag-pdp.is-active');

    if (isOneTime && isSixPackActive) {
      document.documentElement.style.setProperty("--discount-text", '"SAVE 25%"');
    } else {
      document.documentElement.style.setProperty("--discount-text", '"SAVE 40%"');
    }
  }

  // Escucha los cambios en la suscripción
  document.querySelectorAll(".content-subcription-list .header-subcrition")
    .forEach(header => {
      header.addEventListener("click", () => {
        setTimeout(updateDiscountBadge, 50);
      });
    });

  // Escucha también cuando cambie el flavor switcher (ej: click en 3 pack o 6 pack)
  document.querySelectorAll(".flavor-switcher__item").forEach(item => {
    item.addEventListener("click", () => {
      setTimeout(updateDiscountBadge, 50);
    });
  });

  // Inicial
  updateDiscountBadge();


  // Manejo de selección de variantes
  const variantRadios = document.querySelectorAll('.flavor .variant-item input[type="radio"]');
  const quantityRadios = document.querySelectorAll('.quantitys .variant-item input[type="radio"]');

  // Función para manejar el cambio de variante y actualizar la imagen
  function handleVariantChange(radio) {
    if (radio.checked) {
      // Obtener el valor de la variante seleccionada
      const variantValue = radio.value;
      const variantLabel = radio.nextElementSibling;
      const variantImageUrl = variantLabel.style.backgroundImage;

      if (variantImageUrl) {
        // Extraer la URL de la imagen del estilo background-image
        const imageUrl = variantImageUrl.replace(/^url\(['"]+(.+)['"]+\)$/, '$1');

        // Buscar la imagen en el slider principal y navegar a ella
        const mainSlides = document.querySelectorAll('.content-slider-product .swiper-slide img');
        let foundMatch = false;

        // Primero intentamos encontrar una coincidencia exacta de URL
        for (let i = 0; i < mainSlides.length; i++) {
          const slideImgSrc = mainSlides[i].getAttribute('src');

          // Comparar las URLs de las imágenes (ignorando parámetros de tamaño)
          const baseSlideUrl = slideImgSrc.split('?')[0];
          const baseVariantUrl = imageUrl.split('?')[0];

          // Verificar si la URL de la imagen contiene el nombre de archivo de la variante
          if (baseSlideUrl.includes(baseVariantUrl) || baseVariantUrl.includes(baseSlideUrl)) {
            // Navegar al slide correspondiente
            if (mainSwiper) {
              mainSwiper.slideTo(i);
              foundMatch = true;
              break;
            }
          }
        }

        // If no exact match found, search by variant ID
        if (!foundMatch) {
          // Find the slide with the data-variant-id that matches this variant
          const variantSlides = document.querySelectorAll('.content-slider-product .swiper-slide[data-variant-id]');

          for (let i = 0; i < variantSlides.length; i++) {
            const slideVariantId = variantSlides[i].getAttribute('data-variant-id');
            const slideIndex = Array.from(variantSlides[i].parentNode.children).indexOf(variantSlides[i]);

            // Si encontramos un slide con el ID de variante, navegamos a él
            if (slideVariantId && slideIndex !== -1) {
              if (mainSwiper) {
                mainSwiper.slideTo(slideIndex);
                foundMatch = true;
                break;
              }
            }
          }
        }
      }

      // Actualizar el ID de la variante en el formulario
      updateVariantId();
    }
  }

  // Función para filtrar las opciones de quantity disponibles según el flavor seleccionado
  function filterAvailableQuantities(selectedFlavor) {
    // Obtener todos los inputs ocultos de variantes
    const variantInputs = document.querySelectorAll('input[data-variant-flavor]');

    // Crear un conjunto para almacenar las cantidades disponibles para este sabor
    const availableQuantities = new Set();
    const availableQuantitiesData = new Map(); // Para almacenar los objetos completos
    // Recorrer todos los inputs de variantes y encontrar las cantidades disponibles para este sabor
    variantInputs.forEach(input => {
      if (input.getAttribute('data-variant-flavor') === selectedFlavor &&
        input.hasAttribute('data-variant-quantity')) {
        const quantity = input.getAttribute('data-variant-quantity');
        const quantityData = {
          quantity: quantity,
          percentageDiscount: input.getAttribute('data-variant-percentage-discount')
        };

        availableQuantities.add(quantity); // Mantener la clave para validación
        availableQuantitiesData.set(quantity, quantityData); // Almacenar el objeto completo
      }
    });
    // Obtener todos los radio buttons de quantity
    const quantityRadios = document.querySelectorAll('.quantitys .variant-item');

    // Mostrar u ocultar los radio buttons según si están disponibles
    quantityRadios.forEach(item => {
      const radio = item.querySelector('input[type="radio"]');
      if (radio) {
        const quantityValue = radio.value;

        // Si la cantidad está disponible para este sabor, mostrar el radio button
        if (availableQuantities.has(quantityValue)) {
          item.style.display = '';
          const quantityData = availableQuantitiesData.get(quantityValue);

          const discountBadge = item.querySelector('.discount-badge');

          if (quantityData && quantityData.percentageDiscount) {

            if (discountBadge) {
              discountBadge.style.display = '';
              discountBadge.textContent = `SAVE ${quantityData.percentageDiscount}%`;
            }
          } else {
            if (discountBadge) {
              discountBadge.style.display = 'none';
            }
          }
        } else {
          // Si no está disponible, ocultar el radio button
          item.style.display = 'none';
          const discountBadge = item.querySelector('.discount-badge');
          if (discountBadge) {
            discountBadge.style.display = 'none';
          }


          // Si este radio estaba seleccionado, seleccionar el primero disponible
          if (radio.checked) {
            const firstAvailableRadio = document.querySelector(`.quantitys .variant-item input[value="${Array.from(availableQuantities)[0]}"]`);
            if (firstAvailableRadio) {
              firstAvailableRadio.checked = true;
              // Actualizar el ID de la variante
              updateVariantId();
              // Actualizar el badge de descuento de suscripción
              updateSubscriptionDiscountBadge();
            }
          }
        }
      }
    });
  }

  // Agregar eventos para los radios de sabor
  if (variantRadios.length > 0) {
    variantRadios.forEach((radio) => {
      radio.addEventListener('change', function () {
        // Filtrar las opciones de quantity disponibles
        filterAvailableQuantities(this.value);
        // Manejar el cambio de variante
        handleVariantChange(this);
        // Actualizar el badge de descuento de suscripción después del cambio de flavor
        updateSubscriptionDiscountBadge();
      });
    });

    // Filtrar las opciones de quantity disponibles al cargar la página
    const initialSelectedFlavor = document.querySelector('.flavor .variant-item input[type="radio"]:checked');
    if (initialSelectedFlavor) {
      filterAvailableQuantities(initialSelectedFlavor.value);
    }
  }

  // Función para actualizar el badge de descuento de suscripción
  function updateSubscriptionDiscountBadge() {
    // Obtener la opción de quantity seleccionada
    const selectedQuantityRadio = document.querySelector('input[name="option-1"]:checked');
    if (!selectedQuantityRadio) return;

    // Buscar el badge de descuento correspondiente a la opción seleccionada
    const quantityItem = selectedQuantityRadio.closest('.variant-item');
    if (!quantityItem) return;

    const discountBadge = quantityItem.querySelector('.discount-badge');
    const subscriptionBadge = document.querySelector('.header-subcrition label span');

    if (!subscriptionBadge) return;

    if (discountBadge && discountBadge.style.display !== 'none') {
      // Extraer el porcentaje del badge de descuento
      const badgeText = discountBadge.textContent || discountBadge.innerText;
      const percentageMatch = badgeText.match(/(\d+)%/);

      if (percentageMatch) {
        const percentage = percentageMatch[1];
        subscriptionBadge.textContent = `SAVE ${percentage}%`;
        subscriptionBadge.style.display = 'inline'; // Mostrar el badge
      }
    } else {
      // Si no hay descuento, ocultar el badge completamente
      subscriptionBadge.style.display = 'none';
    }
  }

  // Agregar eventos para los radios de cantidad
  if (quantityRadios.length > 0) {
    quantityRadios.forEach((radio) => {
      radio.addEventListener('change', function () {
        // Solo actualizamos el ID de la variante, no cambiamos la imagen
        updateVariantId();

        // Actualizar el badge de descuento de suscripción
        updateSubscriptionDiscountBadge();
      });
    });

    // Ejecutar al cargar la página para establecer el valor inicial
    updateSubscriptionDiscountBadge();
  }

  // Manejar los botones de "Add to Cart"
  /*
  const addToCartButtons = document.querySelectorAll('.button-add-to-cart');
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach((button) => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        
        // Obtener el ID de la variante seleccionada
        const variantIdInput = document.querySelector('input.variant-id');
        if (!variantIdInput) return;
        
        const variantId = variantIdInput.value;
        if (!variantId) {
          console.error('No se ha seleccionado una variante válida');
          return;
        }
        
        // Obtener el tipo de suscripción seleccionado
        const subscriptionType = document.querySelector('input[name="subcription"]:checked');
        const isSubscription = subscriptionType && subscriptionType.value === 'subcription1';
        
        // Crear los datos para enviar al carrito
        const formData = {
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        };
        
        // Si es una suscripción, agregar los datos de suscripción
        if (isSubscription) {
          formData.items[0].selling_plan = getSellingPlanId(); // Implementar esta función si es necesario
        }
        
        // Mostrar indicador de carga
        button.classList.add('loading');
        button.disabled = true;
        
        // Enviar la solicitud para agregar al carrito
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
          // Actualizar el carrito y abrir el drawer
          updateCart();
        })
        .catch(error => {
          console.error('Error al agregar al carrito:', error);
        })
        .finally(() => {
          // Quitar indicador de carga
          button.classList.remove('loading');
          button.disabled = false;
        });
      });
    });
  }
  */

  // Función para obtener el ID del plan de venta (para suscripciones)
  function getSellingPlanId() {
    // Implementar según sea necesario para tu tienda
    // Por ejemplo, podrías tener un input oculto con el ID del plan de venta
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    return sellingPlanInput ? sellingPlanInput.value : null;
  }

  // Función para actualizar el carrito y abrir el drawer
  // function updateCart() {
  //   fetch('/cart.js')
  //     .then(response => response.json())
  //     .then(cart => {
  //       // Abrir el drawer del carrito
  //       const cartDrawer = document.querySelector('cart-drawer');
  //       if (cartDrawer) {
  //         // Actualizar el contenido del drawer con los datos del carrito
  //         fetch('/?sections=cart-drawer,cart-icon-bubble')
  //           .then(response => response.json())
  //           .then(sections => {
  //             cartDrawer.renderContents({ sections });
  //           })
  //           .catch(error => {
  //             console.error('Error al obtener las secciones del carrito:', error);
  //             // Si hay un error, simplemente abrir el drawer sin actualizar
  //             cartDrawer.open();
  //           });
  //       }
  //     })
  //     .catch(error => {
  //       console.error('Error al obtener los datos del carrito:', error);
  //     });
  // }

  // Función para obtener el parámetro de variante de la URL
  function getVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }

  // Función para seleccionar el radio button correcto según el ID de variante
  function selectRadioByVariantId(variantId) {
    if (!variantId) return false;

    // Buscar el input oculto que tiene el ID de variante
    const variantInput = document.querySelector(`input[value="${variantId}"][data-variant-flavor]`);
    if (!variantInput) return false;

    // Obtener los valores de sabor y cantidad
    const flavorValue = variantInput.getAttribute('data-variant-flavor');
    const quantityValue = variantInput.getAttribute('data-variant-quantity');

    // Seleccionar el radio button de sabor correspondiente
    if (flavorValue) {
      const flavorRadio = document.querySelector(`.flavor .variant-item input[value="${flavorValue}"]`);
      if (flavorRadio) {
        flavorRadio.checked = true;
      }
    }

    // Seleccionar el radio button de cantidad correspondiente
    if (quantityValue) {
      const quantityRadio = document.querySelector(`.quantitys .variant-item input[value="${quantityValue}"]`);
      if (quantityRadio) {
        quantityRadio.checked = true;
      }
    }

    return true;
  }

  // Verificar si hay un parámetro de variante en la URL
  const urlVariantId = getVariantFromUrl();
  let variantSelected = false;

  if (urlVariantId) {
    // Intentar seleccionar los radio buttons basados en el ID de variante de la URL
    variantSelected = selectRadioByVariantId(urlVariantId);
  }

  // Inicializar con la variante seleccionada
  const defaultVariantRadio = document.querySelector('.flavor .variant-item input[type="radio"]:checked');
  if (defaultVariantRadio && variantSelected) {
    // Si hay una variante en la URL y se seleccionó correctamente, actualizar la imagen
    handleVariantChange(defaultVariantRadio);
  } /*else {
    // Solo actualizar el ID de la variante sin cambiar la imagen
    updateVariantId();
  }
  */
  // Función para actualizar la URL con el ID de la variante
  function updateUrlWithVariant(variantId) {
    if (!variantId) return;

    // Crear un objeto URL con la URL actual
    const url = new URL(window.location.href);

    // Establecer o actualizar el parámetro 'variant'
    url.searchParams.set('variant', variantId);

    // Actualizar la URL sin recargar la página
    window.history.replaceState({}, '', url.toString());
  }

  // Función para actualizar el ID de la variante en el formulario
  // function updateVariantId() {
  //   // Buscar la variante correspondiente al valor seleccionado
  //   const variantIdInput = document.querySelector('input.variant-id');
  //   if (variantIdInput) {
  //     // Obtener el valor del sabor seleccionado
  //     const flavorRadio = document.querySelector('.flavor .variant-item input[type="radio"]:checked');
  //     //if (!flavorRadio) return;

  //     let flavorValue = null;
  //     if (flavorRadio) {
  //       flavorValue = flavorRadio.value;
  //     }

  //     // Si hay más de una opción (sabor y cantidad), necesitamos combinar ambas
  //     const quantityRadios = document.querySelectorAll('.quantitys .variant-item input[type="radio"]:checked');
  //     let quantityValue = '';
  //     if (quantityRadios.length > 0) {
  //       quantityValue = quantityRadios[0].value;
  //     }

  //     // Buscar el input oculto que tiene los datos de la variante
  //     let variantSelector = null;
  //     if (flavorValue) {
  //       variantSelector = document.querySelector(`[data-variant-flavor="${flavorValue}"]${quantityValue ? `[data-variant-quantity="${quantityValue}"]` : ''}`);
  //     } else if (quantityValue) {
  //       //es flavor y no quantity porque caundo no tiene elotro tipo de variante cae en option 1, y asi se guarda el flavor
  //       variantSelector = document.querySelector(`[data-variant-flavor="${quantityValue}"]`);
  //     }
  //     if (variantSelector) {
  //       const variantId = variantSelector.value;
  //       variantIdInput.value = variantId;

  //       // Update the URL with the variant ID
  //       updateUrlWithVariant(variantId);

  //       console.log(`Variant updated: ${flavorValue} ${quantityValue} - ID: ${variantId}`);
  //     } else {
  //       //console.log(`No se encontró variante para: ${flavorValue} ${quantityValue}`);
  //     }
  //   }
  // }

  const tabsInfo = document.querySelector(".content-tabs-info");
  if (!tabsInfo) return;

  const tabButtons = tabsInfo.querySelectorAll("ul li");
  const tabContents = tabsInfo.querySelectorAll(
    ".content-tabs-info-content .content-tabs"
  );

  tabButtons.forEach((btn, idx) => {
    btn.addEventListener("click", function () {
      tabButtons.forEach((b) => b.classList.remove("active"));
      tabContents.forEach((c) => c.classList.remove("active"));

      btn.classList.add("active");
      if (tabContents[idx]) {
        tabContents[idx].classList.add("active");
      }
    });
  });


  const openModalBtns = document.querySelectorAll(".open-modal-nutrition");
  const modalNutritions = document.querySelector(".modal-nutritions");
  const closeModalBtn = document.querySelector(
    ".modal-nutritions .close-modal"
  );

  if (openModalBtns && modalNutritions) {
    openModalBtns.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        modalNutritions.classList.add("active");
      });
    });
  }

  if (closeModalBtn && modalNutritions) {
    closeModalBtn.addEventListener("click", function () {
      modalNutritions.classList.remove("active");
    });
  }

  modalNutritions?.addEventListener("click", function (e) {
    if (e.target === modalNutritions) {
      modalNutritions.classList.remove("active");
    }
  });

  const mobileTabs = document.querySelectorAll(
    ".content-tabs-info-mobile .content-item"
  );

  mobileTabs.forEach((item, idx) => {
    const header = item.querySelector("h4");
    const plusIcon = header.querySelector("span:not(.item-active)");
    const minusIcon = header.querySelector(".item-active");
    const content = item.querySelector(".content-item-text");

    // if (idx === 0) {
    //   item.classList.add("active");
    //   if (content) {
    //     content.style.maxHeight = content.scrollHeight + "px";
    //     content.style.paddingBottom = "5px";
    //   }
    //   plusIcon.style.display = "none";
    //   minusIcon.style.display = "inline-flex";
    // } else {
    //   item.classList.remove("active");
    //   if (content) {
    //     content.style.maxHeight = null;
    //     content.style.paddingBottom = null;
    //   }
    //   plusIcon.style.display = "inline-flex";
    //   minusIcon.style.display = "none";
    // }

    header.addEventListener("click", function () {
      mobileTabs.forEach((other, otherIdx) => {
        const otherHeader = other.querySelector("h4");
        const otherPlus = otherHeader.querySelector("span:not(.item-active)");
        const otherMinus = otherHeader.querySelector(".item-active");
        const otherContent = other.querySelector(".content-item-text");
        if (other !== item) {
          other.classList.remove("active");
          if (otherContent) {
            otherContent.style.maxHeight = null;
            otherContent.style.paddingBottom = null;
          }
          otherPlus.style.display = "inline-flex";
          otherMinus.style.display = "none";
        }
      });
      item.classList.toggle("active");
      if (item.classList.contains("active")) {
        if (content) {
          content.style.maxHeight = content.scrollHeight + "px";
          content.style.paddingBottom = "5px";
        }
        plusIcon.style.display = "none";
        minusIcon.style.display = "inline-flex";
      } else {
        if (content) {
          content.style.maxHeight = null;
          content.style.paddingBottom = null;
        }
        plusIcon.style.display = "inline-flex";
        minusIcon.style.display = "none";
      }
    });
  });
}
